var _path;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgChevronUp(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 11,
    viewBox: "0 0 18 11",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M9.69952 0.286449L17.7102 8.20653C18.0966 8.58851 18.0966 9.2078 17.7102 9.58973L16.7759 10.5135C16.3902 10.8948 15.7651 10.8955 15.3785 10.5151L8.99998 4.23832L2.62147 10.5152C2.23487 10.8956 1.60978 10.8949 1.22409 10.5135L0.289763 9.58977C-0.0965876 9.2078 -0.0965876 8.58851 0.289763 8.20657L8.30048 0.286489C8.68679 -0.0954898 9.31316 -0.0954895 9.69952 0.286449Z"
  })));
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgChevronUp);
export default __webpack_public_path__ + "static/media/ChevronUp.d71637d4970fbd43e60c341358e2dc7c.svg";
export { ForwardRef as ReactComponent };